import { useInfiniteQuery } from 'react-query';

import {
  FOLLOWER,
  FOLLOWING,
  PaginatedFollowers,
  PaginatedFollowings,
  getPaginatedFollows,
} from '../utils/backend-api/subscriber_directory';

export default function useFollows({
  followType,
  username,
}: {
  followType: typeof FOLLOWER | typeof FOLLOWING;
  username: string;
}) {
  const { data, isLoading, fetchNextPage, hasNextPage } = useInfiniteQuery<
    PaginatedFollowers | PaginatedFollowings
  >(
    `more-${followType}s`,
    ({ pageParam = 1 }) => {
      const sanitizedParams = {
        username: username,
        page: pageParam,
        follow_type: followType,
      };

      return getPaginatedFollows(sanitizedParams);
    },
    {
      getNextPageParam: (lastPage) =>
        (lastPage as PaginatedFollowers).followersNextpage ??
        (lastPage as PaginatedFollowings).followingNextPage,
    }
  );

  return { data, isLoading, fetchNextPage, hasNextPage };
}
